import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// ─── LIST ─────────────────────────────────────────────────────────────────────

export const fetchFeatures = async (filters = {}) => {
  try {
    const params = {};
    if (filters.search) params.search = filters.search;
    if (filters.filter && filters.filter !== "Default")
      params.filter = filters.filter.toLowerCase();
    if (filters.sort) params.sort = filters.sort;

    const response = await authenticatedAxios.get(`${baseurl}plans/feature/`, {
      params,
    });
    return response.data?.data || [];
  } catch (error) {
    console.error("fetchFeatures error:", error);
    return [];
  }
};

// ─── DETAIL ───────────────────────────────────────────────────────────────────

export const fetchFeatureById = async (id) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}plans/feature/?id=${id}`
    );
    return { data: response.data?.data || null, error: null };
  } catch (error) {
    console.error("fetchFeatureById error:", error);
    const errorCode = error?.response?.data?.error_code;
    return { data: null, error: errorCode || "UNKNOWN" };
  }
};

// ─── ADD ──────────────────────────────────────────────────────────────────────

export const addFeature = async (payload) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}plans/feature/`,
      payload
    );
    const result = response.data;
    if (result.response_code === 1) {
      return { success: true, data: result.data };
    }
    return { success: false, message: result.message || "Something went wrong" };
  } catch (error) {
    console.error("addFeature error:", error);
    return { success: false, message: "Network error" };
  }
};

// ─── EDIT ─────────────────────────────────────────────────────────────────────

export const editFeature = async (id, payload) => {
  try {
    const response = await authenticatedAxios.put(
      `${baseurl}plans/feature/?id=${id}`,
      payload
    );
    const result = response.data;
    if (result.response_code === 1) {
      return { success: true, data: result.data };
    }
    return { success: false, message: result.message || "Something went wrong" };
  } catch (error) {
    console.error("editFeature error:", error);
    return { success: false, message: "Network error" };
  }
};

// ─── DELETE ───────────────────────────────────────────────────────────────────

export const deleteFeature = async (id) => {
  try {
    const response = await authenticatedAxios.delete(
      `${baseurl}plans/feature/?id=${id}`
    );
    return { success: response.status >= 200 && response.status < 300 };
  } catch (error) {
    console.error("deleteFeature error:", error);
    return { success: false };
  }
};

// ─── ARCHIVE (single) ─────────────────────────────────────────────────────────

export const archiveFeature = async (id) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}plans/feature/archive/?id=${id}`
    );
    return { success: response.status >= 200 && response.status < 300 };
  } catch (error) {
    console.error("archiveFeature error:", error);
    return { success: false };
  }
};

// ─── ARCHIVE (bulk) ───────────────────────────────────────────────────────────

export const archiveFeaturesBulk = async (idList) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}plans/feature/archive/`,
      { id_list: idList }
    );
    return { success: response.status >= 200 && response.status < 300 };
  } catch (error) {
    console.error("archiveFeaturesBulk error:", error);
    return { success: false };
  }
};